module.exports = __webpack_public_path__ + "img/1557614108014092290.4fc8dc31.png";